
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/home";
import { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import AboutUs from "./pages/aboutUs";
import Contact from "./pages/contact";
import PrivacyPolicy from "./pages/privacy-policy";
import TCUsers from "./pages/terms-and-conditions-users";
import TCMerchant from "./pages/terms-and-conditions-merchants";

function App() {

    // Initialize AOS once for the entire app
    useEffect(() => {
      AOS.init({
        duration: 1000,
        easing: "ease-in-out",
        once: false,
      });
    }, []);

  return (
    <Router>      
        <Routes>
          {/* Your routes here */}
          <Route path = "/" element = {<Home />} />
          <Route path = "/aboutUs" element = {<AboutUs />} />
          <Route path = "/contact" element = {<Contact />} />
          <Route path = "/privacy-policy" element = {<PrivacyPolicy />} />
          <Route path = "/terms-and-conditions-users" element = {<TCUsers />} />
          <Route path = "/terms-and-conditions-merchants" element = {<TCMerchant />} />
        </Routes>
    </Router>
  );
}

export default App;
